import React from 'react';
import LegalPage from '../components/landing/LegalPage';

export default function Privacy() {
  return (
    <LegalPage title="Privacy" lastUpdated="2026-04-09">
      <h2>Who we are</h2>
      <p>
        MySecureRoom is a product of Ahad Software House, a UK-based software
        studio. We're building a private, encrypted tool for holding your
        values, goals, and daily practice. This policy explains what happens
        to any information you give us today, while we're pre-launch.
      </p>

      <h2>What we collect, right now</h2>
      <p>
        The only thing we collect is your email address, and only if you
        submit it via the waitlist form. We store:
      </p>
      <ul>
        <li>Your email address (lowercased and trimmed)</li>
        <li>The timestamp you submitted it</li>
        <li>A marker that says you came from the landing page</li>
      </ul>
      <p>
        We don't collect your IP address, your browser, your user agent, or
        any cookies beyond the one described below. The site has no analytics
        cookies at all.
      </p>

      <h2 id="cookies">Cookies</h2>
      <p>
        A cookie is a small text file that a website can ask your browser to
        store. We use cookies sparingly and explain exactly what each one does
        below.
      </p>
      <p><strong>On the pre-launch site today, we use one cookie:</strong></p>
      <ul>
        <li>
          <strong>msr_cookie_consent</strong> — remembers that you've seen the
          cookie notice and your preferences (if any). Strictly necessary,
          cannot be disabled. Expires after 1 year. No data from this cookie
          is sent to us or anyone else.
        </li>
      </ul>
      <p><strong>On the pre-launch site today, we do NOT use:</strong></p>
      <ul>
        <li>Analytics cookies (no Google Analytics, no Plausible, nothing)</li>
        <li>Marketing cookies</li>
        <li>Cross-site tracking</li>
        <li>Third-party cookies of any kind</li>
      </ul>
      <p><strong>When early access opens, we will introduce:</strong></p>
      <ul>
        <li>
          A session cookie (strictly necessary) — to keep you logged in between
          visits. HttpOnly, Secure, SameSite=Strict. We'll update this policy
          before it ships.
        </li>
      </ul>
      <p>
        We may also introduce optional functional or analytics cookies when
        the app launches. If we do, you'll see an updated cookie notice and
        can accept or decline each category. We will never set marketing
        cookies.
      </p>
      <p>
        You can review and change your cookie preferences at any time via the{' '}
        <strong>Cookie preferences</strong> link in the footer of every page.
      </p>

      <h2>What happens when we launch</h2>
      <p>
        When MySecureRoom opens for early access, everything you put into the
        app — your values, your goals, your journal, your tasks — will be
        encrypted on your device with a key only you have. We'll publish a
        more detailed privacy policy at that point. Until then, this page
        covers only the waitlist.
      </p>

      <h2>Why we collect your email</h2>
      <p>
        Exactly one reason: to send you one email when early access opens.
        No marketing, no newsletters, no drip campaigns, no "just checking
        in" messages.
      </p>

      <h2>How long we keep it</h2>
      <p>Your email stays in our waitlist until one of three things happens:</p>
      <ul>
        <li>
          We open early access, you create an account, and your waitlist entry
          is no longer needed
        </li>
        <li>You ask us to delete it</li>
        <li>The project is abandoned (in which case we delete the whole waitlist)</li>
      </ul>

      <h2>Your rights</h2>
      <p>You can, at any time, ask us to:</p>
      <ul>
        <li>Tell you what we have on file for you</li>
        <li>Delete it</li>
        <li>Correct it</li>
      </ul>
      <p>
        To do any of those, email{' '}
        <strong>khawaja.nav@gmail.com</strong> with the subject line
        "waitlist request."
      </p>

      <h2>Where your data lives</h2>
      <p>
        Waitlist entries are stored in a Cloudflare D1 database on
        Cloudflare's infrastructure. Cloudflare is a US-based company with
        data centers globally; your data may be stored in any of those
        regions.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        We'll update this page when we open early access with a fuller policy
        covering the app itself. The "last updated" date at the top of this
        page will change when that happens.
      </p>

      <h2>Contact</h2>
      <p>
        For any privacy questions, email <strong>khawaja.nav@gmail.com</strong>.
      </p>
    </LegalPage>
  );
}
